// extracted by mini-css-extract-plugin
module.exports = {"mapLayersControlContainer":"MapLayersControl_mapLayersControlContainer__B0JDB","trafficLegendContainer":"MapLayersControl_trafficLegendContainer__EqEjX"};